module.exports = __webpack_public_path__ + "img/register.84cd032f.png";